import React from "react";
import { Input, Label, ComboBox, ComboBoxItem, FlexBox, FlexBoxDirection, Button } from "@ui5/webcomponents-react";

const SocioeconomicForm4 = ({ formData, onFormChange, handlePrevious, handleNext }) => {
  // Define the options with corresponding numbers
  const houseExtensionOptions = [
    { value: 1, label: "1 - Oo, pero pinangasiwaan ng Engineer/Arkitekto" },
    { value: 2, label: "2 - Oo, pero hindi pinangasiwaan ng Engineer/Arkitekto" },
    { value: 3, label: "3 - Hindi" },
    { value: 4, label: "4 - Hindi Alam" },
  ];

  const wallThicknessOptions = [
    { value: 1, label: "1 - Oo" },
    { value: 2, label: "2 - Hindi" },
    { value: 3, label: "3 - Hindi Alam" },
  ];

  const steelStandardOptions = [
    { value: 1, label: "1 - Oo, 10 mm na bakal ang ginamit, nakatali at naayon sa tamang pagitan" },
    { value: 2, label: "2 - Hindi, kakaunti at mas maliit sa 10mm na bakal" },
    { value: 3, label: "3 - Walang bakal na ginamit" },
    { value: 4, label: "4 - Hindi Alam" },
  ];

  const wallSupportOptions = [
    { value: 1, label: "1 - Wala, lahat ng suportadong dingding ay mas makitid sa 3 metrong luwang" },
    { value: 2, label: "2 - Oo, isa lamang ang dingding na walang suporta o tukod may luwang na higit 3 metro" },
    { value: 3, label: "3 - Hindi Alam" },
  ];

  const gableWallMaterialOptions = [
    { value: 1, label: "1 - Yari sa bakal" },
    { value: 2, label: "2 - Yari sa light materials, hollow blocks, at walang kabalyete" },
    { value: 3, label: "3 - Hindi maayos ang paglalagay ng hollow blocks, laryo (brick), o bato" },
    { value: 4, label: "4 - Hindi Alam" },
  ];

  const foundationMaterialOptions = [
    { value: 1, label: "1 - Konkreto" },
    { value: 2, label: "2 - Hindi konkreto" },
    { value: 3, label: "3 - Hindi Alam" },
  ];

  const soilConditionOptions = [
    { value: 1, label: "1 - Matigas" },
    { value: 2, label: "2 - Malambot" },
    { value: 3, label: "3 - Hindi Alam" },
  ];

  const houseConditionOptions = [
    { value: 1, label: "1 - Matibay" },
    { value: 2, label: "2 - Mahina/Mahuna" },
    { value: 3, label: "3 - Hindi Alam" },
  ];

  return (
    <div style={{ padding: "2rem", maxWidth: "1200px", margin: "auto" }}>
      <h2>Step 4: Disaster Risk Reduction and Management</h2>

      {/* C7. House Extension */}
      <h3>C7. Ang bahay ba na kasalukuyang tinitirahan ay sagunyap/pahulog/extension?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select House Extension</Label>
      <ComboBox
        value={houseExtensionOptions.find(option => option.value === formData.houseExtension)?.label || ""}
        onChange={(e) => {
          const selectedValue = houseExtensionOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("houseExtension", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {houseExtensionOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.houseExtension === 99 && (
        <Input
          name="houseExtensionOther"
          value={formData.houseExtensionOther || ""}
          onInput={(e) => onFormChange("houseExtensionOther", e.target.value.toUpperCase())}
          placeholder="Specify other house extension"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* C8. Wall Thickness */}
      <h3>C8. Ang dingding ba ng inyong bahay na kasalukuyang inyong tinitirahan ay ginamitan ng 6 na pulgada (inches) o 150 mm na kapal ng hollowblocks?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Wall Thickness</Label>
      <ComboBox
        value={wallThicknessOptions.find(option => option.value === formData.wallThickness)?.label || ""}
        onChange={(e) => {
          const selectedValue = wallThicknessOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("wallThickness", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {wallThicknessOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.wallThickness === 99 && (
        <Input
          name="wallThicknessOther"
          value={formData.wallThicknessOther || ""}
          onInput={(e) => onFormChange("wallThicknessOther", e.target.value.toUpperCase())}
          placeholder="Specify other wall thickness"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* C9. Steel Standard */}
      <h3>C9. Ang bakal ba na ginamit sa inyong pader/dingding ay batay sa pamantayan at may tamang agwat?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Steel Standard</Label>
      <ComboBox
        value={steelStandardOptions.find(option => option.value === formData.steelStandard)?.label || ""}
        onChange={(e) => {
          const selectedValue = steelStandardOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("steelStandard", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {steelStandardOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.steelStandard === 99 && (
        <Input
          name="steelStandardOther"
          value={formData.steelStandardOther || ""}
          onInput={(e) => onFormChange("steelStandardOther", e.target.value.toUpperCase())}
          placeholder="Specify other steel standard"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* C10. Wall Support */}
      <h3>C10. Meron bang dingding na walang haligi at biga na higit 3 metro ang pagitan?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Wall Support</Label>
      <ComboBox
        value={wallSupportOptions.find(option => option.value === formData.wallSupport)?.label || ""}
        onChange={(e) => {
          const selectedValue = wallSupportOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("wallSupport", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {wallSupportOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.wallSupport === 99 && (
        <Input
          name="wallSupportOther"
          value={formData.wallSupportOther || ""}
          onInput={(e) => onFormChange("wallSupportOther", e.target.value.toUpperCase())}
          placeholder="Specify other wall support"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* C11. Gable Wall Material */}
      <h3>C11. Anong materyales ang ginamit para sa kabalyete (gable wall) ng inyong bahay?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Gable Wall Material</Label>
      <ComboBox
        value={gableWallMaterialOptions.find(option => option.value === formData.gableWallMaterial)?.label || ""}
        onChange={(e) => {
          const selectedValue = gableWallMaterialOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("gableWallMaterial", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {gableWallMaterialOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.gableWallMaterial === 99 && (
        <Input
          name="gableWallMaterialOther"
          value={formData.gableWallMaterialOther || ""}
          onInput={(e) => onFormChange("gableWallMaterialOther", e.target.value.toUpperCase())}
          placeholder="Specify other gable wall material"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* C12. Foundation Material */}
      <h3>C12. Saan gawa ang pundasyon ng bahay?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Foundation Material</Label>
      <ComboBox
        value={foundationMaterialOptions.find(option => option.value === formData.foundationMaterial)?.label || ""}
        onChange={(e) => {
          const selectedValue = foundationMaterialOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("foundationMaterial", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {foundationMaterialOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.foundationMaterial === 99 && (
        <Input
          name="foundationMaterialOther"
          value={formData.foundationMaterialOther || ""}
          onInput={(e) => onFormChange("foundationMaterialOther", e.target.value.toUpperCase())}
          placeholder="Specify other foundation material"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* C13. Soil Condition */}
      <h3>C13. Ano ang kondisyon ng lupa na tinatayuan ng inyong bahay?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Soil Condition</Label>
      <ComboBox
        value={soilConditionOptions.find(option => option.value === formData.soilCondition)?.label || ""}
        onChange={(e) => {
          const selectedValue = soilConditionOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("soilCondition", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {soilConditionOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.soilCondition === 99 && (
        <Input
          name="soilConditionOther"
          value={formData.soilConditionOther || ""}
          onInput={(e) => onFormChange("soilConditionOther", e.target.value.toUpperCase())}
          placeholder="Specify other soil condition"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* C14. House Condition */}
      <h3>C14. Sa inyong palagay, ano ang kabuuang kalagayan ng bahay sa panahon ng kalamidad?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select House Condition</Label>
      <ComboBox
        value={houseConditionOptions.find(option => option.value === formData.houseCondition)?.label || ""}
        onChange={(e) => {
          const selectedValue = houseConditionOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("houseCondition", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {houseConditionOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.houseCondition === 99 && (
        <Input
          name="houseConditionOther"
          value={formData.houseConditionOther || ""}
          onInput={(e) => onFormChange("houseConditionOther", e.target.value.toUpperCase())}
          placeholder="Specify other house condition"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}
    </div>
  );
};

export default SocioeconomicForm4;